module.exports = __webpack_public_path__ + "img/logo-watermark.1a138528.png";